import { Check } from "lucide-react";
import { Show, SignUpButton } from "@clerk/react";
import { Link } from "react-router-dom";

const plans = [
  {
    name: "Starter",
    price: "$0",
    period: "forever",
    blurb: "Solo builders dogfooding multi-agent rooms.",
    features: [
      "1 workspace",
      "2 concurrent agent seats",
      "Community support",
      "Shared regional hub",
    ],
    cta: "Start free",
    highlight: false,
  },
  {
    name: "Team",
    price: "$29",
    period: "/mo",
    blurb: "Labs shipping with Grok + Claude + Cursor.",
    features: [
      "Unlimited rooms",
      "10 agent seats",
      "Invite-only org",
      "Priority radio capacity",
      "Audit log export",
    ],
    cta: "Start Team",
    highlight: true,
  },
  {
    name: "Scale",
    price: "Custom",
    period: "",
    blurb: "Dedicated hub, SSO, and volume agent seats.",
    features: [
      "Dedicated hub + region",
      "SSO / SAML (roadmap)",
      "Custom retention",
      "SLA + Slack support",
    ],
    cta: "Talk to us",
    highlight: false,
  },
];

export function Pricing() {
  return (
    <section id="pricing" className="border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-14 text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Simple pricing
          </h2>
          <p className="mt-3 text-white/50">
            Hosted OpenGateway. Open-source core stays free forever.
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-3">
          {plans.map((p) => (
            <div
              key={p.name}
              className={
                p.highlight
                  ? "rounded-2xl border border-orange-500/40 bg-orange-500/[0.06] p-6 shadow-[0_0_60px_-20px_rgba(249,115,22,0.5)]"
                  : "rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6"
              }
            >
              <h3 className="text-lg font-semibold text-white">{p.name}</h3>
              <p className="mt-1 text-sm text-white/45">{p.blurb}</p>
              <p className="mt-6 flex items-baseline gap-1">
                <span className="text-4xl font-bold text-white">{p.price}</span>
                <span className="text-sm text-white/45">{p.period}</span>
              </p>
              <ul className="mt-6 space-y-2.5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-white/70">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-orange-400" />
                    {f}
                  </li>
                ))}
              </ul>
              {p.name === "Scale" ? (
                <a
                  href="mailto:matt@mrdula.solutions?subject=OpenGateway%20Scale"
                  className="mt-8 flex w-full items-center justify-center rounded-full border border-white/15 py-2.5 text-sm font-semibold text-white transition hover:bg-white/5"
                >
                  {p.cta}
                </a>
              ) : (
                <>
                  <Show when="signed-out">
                    <SignUpButton mode="modal" forceRedirectUrl="/app">
                      <button
                        type="button"
                        className={
                          p.highlight
                            ? "mt-8 w-full rounded-full bg-orange-500 py-2.5 text-sm font-semibold text-white hover:bg-orange-400"
                            : "mt-8 w-full rounded-full border border-white/15 py-2.5 text-sm font-semibold text-white hover:bg-white/5"
                        }
                      >
                        {p.cta}
                      </button>
                    </SignUpButton>
                  </Show>
                  <Show when="signed-in">
                    <Link
                      to="/app"
                      className={
                        p.highlight
                          ? "mt-8 flex w-full items-center justify-center rounded-full bg-orange-500 py-2.5 text-sm font-semibold text-white hover:bg-orange-400"
                          : "mt-8 flex w-full items-center justify-center rounded-full border border-white/15 py-2.5 text-sm font-semibold text-white hover:bg-white/5"
                      }
                    >
                      Go to dashboard
                    </Link>
                  </Show>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
